var FuzzyReaction = require('../bootstrap').FuzzyReaction;
var AppDispatcher = FuzzyReaction.Dispatcher;
var AppActionConstants = require('../constants/AppActionConstants');
var assign = require('object-assign');
var ModelStore = FuzzyReaction.Stores.ModelStore;

/**
 * Data stores
 * @type {Array}
 * @private
 */
// Store for user table data
var _resourceListData = [];
var _legalDisclaimer = {};

/**
 * User store logic
 *
 * @type {*|exports}
 */
var StringsStore = assign({}, ModelStore, {
	getResourceListData: function () {
		return _resourceListData;
	},

	getLegalDisclaimer: function () {
		return _legalDisclaimer;
	}
});

/**
 * Event Listeners
 */
StringsStore.dispatchToken = AppDispatcher.register(function(action) {
	switch(action.type) {
		case 'DOCUMENTS_LISTED':
			_legalDisclaimer = action.data[0];

			StringsStore.emitChange();
			break;
		case 'DOCUMENTS_UPDATED':
			console.log('received', action.data);
			_legalDisclaimer = action.data;

			StringsStore.emitChange();
			break;
	}
});

module.exports = StringsStore;
